export default class VoiceItem {
  constructor(
    id,
    name,
    voiceLink,
    imgSrc,
    isFavor,
    updatedTime,
    receivedTime,
    rarity,
    isPlay,
    amount
  ) {
    this.id = id
    this.name = name
    this.voiceLink = voiceLink
    this.imgSrc = imgSrc
    this.isFavor = isFavor
    this.updatedTime = updatedTime
    this.isPlay = false
    this.receivedTime = receivedTime
    this.rarity = rarity
    this.isPlay = isPlay
    this.amount = amount
  }
}
